import { ReactNode } from 'react'
import cx from 'classnames'
import Styles from './ProfileHeader.module.scss'

interface Props {
  coverImage: ReactNode
  profileImage: ReactNode
  classNames?: {
    profileImage?: string
  }
}

export const ProfileHeader = ({ coverImage, profileImage, classNames }: Props) => (
  <div className={Styles.header}>
    <div className={Styles.coverImage}>{coverImage}</div>
    <div className={cx(Styles.profileImage, classNames?.profileImage)}>{profileImage}</div>
  </div>
)
